import React from 'react';
import Skeleton from '@/components/@IntranetLibrary/Skeleton';

const ApprovalSkeleton = () => {
  return (
    <div
      style={{
        display: 'flex',
        paddingTop: '8px',
        paddingBottom: '15px',
        borderBottom: '1px solid var(--dk-line, #e7e9ec)',
        height: '108px',
        flexDirection: 'column',
        gap: '8px',
        boxSizing: 'content-box',
        zIndex: 0,
      }}
    >
      <Skeleton width={66} height={24} />
      <Skeleton width={184} height={24} />
      <div style={{ display: 'flex', gap: '8px' }}>
        <Skeleton width={63} height={18} />
        <div
          style={{ width: '1px', height: '100%', backgroundColor: 'var(--dk-bg-strong, #e7e9ec)' }}
        ></div>
        <Skeleton width={184} height={18} />
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Skeleton width={50} height={18} />
        <div
          style={{
            display: 'flex',
            gap: '4px',
            alignItems: 'center',
          }}
        >
          <Skeleton variant={'circle'} width={5} height={5} />
          <Skeleton width={30} height={18} />
          <Skeleton width={50} height={18} />
        </div>
      </div>
    </div>
  );
};

export default ApprovalSkeleton;
